import React from 'react';

interface TripodStandProps {
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number;
}

export function TripodStand({ position = [0, 0, 0], rotation = [0, 0, 0], scale = 1 }: TripodStandProps) {
  const height = 1.5;
  const radius = 0.6;
  const legRadius = 0.05;

  return (
    <group position={position} rotation={rotation} scale={scale}>
      {/* Top Ring */}
      <mesh position={[0, height, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[radius, legRadius, 16, 32]} />
        <meshStandardMaterial color="#333333" metalness={0.8} roughness={0.4} />
      </mesh>
      
      {/* Legs */}
      {[0, 1, 2].map((i) => {
        const angle = (i * Math.PI * 2) / 3;
        const x = Math.cos(angle) * radius;
        const z = Math.sin(angle) * radius;
        // Angles slightly outwards
        const leanAngle = 0.1;
        
        return (
          <group key={i} position={[x, height, z]} rotation={[0, -angle, leanAngle]}>
            <mesh position={[0, -height/2, 0]}>
              <cylinderGeometry args={[legRadius, legRadius, height, 16]} />
              <meshStandardMaterial color="#333333" metalness={0.8} roughness={0.4} />
            </mesh>
          </group>
        );
      })}
    </group>
  );
}
